import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetch = (url: string, options = undefined) => {
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const errorHandler = e => {
    setError(e);
  };

  useEffect(() => {
    if (url) {
      const doFetch = async () => {
        setLoading(true);
        try {
          const res = await axios.get(url, options);
          if (res.status === 200 ) {
            setData(res.data);
          } else {
            errorHandler(res.statusText);
          }
        } catch (e) {
          errorHandler(e);
        } finally {
          setLoading(false);
        }
      };
      doFetch();
    }
  }, [url, options]);

  return { data, error, loading };
};

export default useFetch;
